export default __webpack_public_path__ + "static/media/userTop.fd0b8f7c.svg";